<template>
  <section class="mine-page">
    <van-pull-refresh
      ref="refreshRef"
      v-model="refreshing"
      class="mine-refresh"
      :head-height="46"
      @refresh="loadMineData(false)"
    >
      <template #pulling="{ distance }">
        <CustomPullRefreshHead :distance="distance" />
      </template>
      <template #loosing="{ distance }">
        <CustomPullRefreshHead :distance="distance" />
      </template>
      <template #loading>
        <CustomPullRefreshHead loading :distance="30" />
      </template>
      <AppNavBar
        class="mine-hero__nav"
        :title="t('mine.title')"
        :left-arrow="false"
        :border="false"
        :fixed="true"
        :placeholder="false"
        :auto-back="false"
        :background-color="
          showHeroTopSolid ? 'var(--wp-color-brand-1)' : 'transparent'
        "
        text-color="#ffffff"
      >
        <!-- todo -->
        <!-- <template #right>
          <app-image
            class="mine-hero__qr"
            @click="router.push('/mine/code')"
            src="@/assets/images/settingImage/qucode_white_icon.png"
            alt=""
          />
        </template> -->
      </AppNavBar>
      <header class="mine-hero">
        <AppSvgIcon
          class="mine-hero__background"
          name="mine-bg"
          size="100%"
          color="var(--wp-color-brand-1)"
        />
        <div class="mine-hero__profile">
          <div class="mine-hero__profile_information">
            <button
              type="button"
              class="mine-hero__avatar-wrap"
              :disabled="avatarUploading"
              @click="triggerAvatarSelect"
            >
              <app-image
                v-if="avatarUrl"
                class="mine-hero__avatar-image"
                :src="avatarUrl"
                alt=""
              />
              <div v-else class="mine-hero__avatar">{{ avatarText }}</div>
              <app-image
                class="mine-hero__avatar-edit"
                src="@/assets/images/settingImage/shootin_icon.png"
                alt=""
              />
            </button>
            <input
              ref="avatarAlbumInputRef"
              class="mine-hero__avatar-input"
              type="file"
              accept="image/*"
              @change="handleAvatarFileChange"
            />
            <input
              ref="avatarCameraInputRef"
              class="mine-hero__avatar-input"
              type="file"
              accept="image/*"
              capture="user"
              @change="handleAvatarFileChange"
            />
            <div class="mine-hero__info">
              <div class="mine-hero__name-row">
                <div class="accountName">{{ accountName }}</div>
                <button v-if="loggedIn" type="button" @click="editName">
                  <app-image src="@/assets/images/editInfo_icon_2.png" alt="" />
                </button>
              </div>
              <button type="button" class="mine-hero__id" @click="copyUserId">
                <span>ID: {{ userNum }}</span>
                <app-image
                  src="@/assets/images/common_copy_icon_white.png"
                  alt=""
                />
              </button>
            </div>
          </div>
          <div class="mine-hero__profile_invite" @click="openInvite">
            {{ t("invite.invitationCommission") }}
            <app-image class="invite" :src="inviteLogoIcon"></app-image>
          </div>

          <!-- <button
            type="button"
            class="mine-hero__sign"
            :class="{ 'mine-hero__sign--done': !canCheckIn }"
            :disabled="!loggedIn"
            @click="handleCheckIn"
          >
            {{ canCheckIn ? t("mine.signIn") : t("mine.signedIn") }}
          </button> -->
        </div>

        <section ref="pointsCardRef" class="points-card">
          <div ref="pointsCarouselRef" class="points-card__carousel">
            <div
              v-for="card in levelCards"
              :key="card.label"
              class="points-card__item"
            >
              <PointsLevelCard
                :card="card"
                :tag-text="
                  card.isPartner ? t('invite.partner') : t('mine.currentLevel')
                "
                :join-text="t('invite.partnerJoinNow')"
                variant="mine"
                @join-partner="openPartnerQuestionnaire"
              />
            </div>
          </div>
        </section>
      </header>

      <div class="mine-body">
        <section class="mine-tab">
          <CardPaymentBanner class="mine-card-payment" />

          <section class="invite-card">
            <div class="invite-card-label">
              <div>{{ t("invite.myExclusiveInvite") }}</div>
              <span @click="openRewardDetails"
                >{{ t("invite.viewFullRecords") }}
                <van-icon
                  name="arrow"
                  size="14"
                  color="var(--wp-color-brand-1)"
                  class="invite-card-label__arrow"
                />
              </span>
            </div>

            <div v-if="isInviteLocked" class="invite-card__unlock-tip">
              <span class="invite-card__unlock-icon" aria-hidden="true">
                <img
                  class="invite-card__unlock-icon-shackle"
                  :src="inviteUnlockLockShackle"
                  alt=""
                />
                <img
                  class="invite-card__unlock-icon-body"
                  :src="inviteUnlockLockBody"
                  alt=""
                />
                <img
                  class="invite-card__unlock-icon-keyhole"
                  :src="inviteUnlockLockKeyhole"
                  alt=""
                />
              </span>
              <div class="invite-card__unlock-copy">
                <p>{{ t("invite.unlockInviteTitle") }}</p>
                <p>{{ t("invite.unlockInviteDesc") }}</p>
              </div>
            </div>

            <div class="invite-card__row">
              <span>{{ t("invite.invitationCode") }}</span>
              <div
                class="invite-card__value"
                :class="{ 'invite-card__value--locked': isInviteLocked }"
              >
                <template v-if="isInviteLocked">
                  <div class="value">{{ t("invite.notUnlocked") }}</div>
                  <AppSvgIcon :src="lockIcon" size="14" />
                </template>
                <template v-else>
                  <div class="value">{{ invitationCodeText }}</div>
                  <button type="button" @click="copyText(invitationCodeText)">
                    <app-image
                      src="@/assets/images/common_copy_icon_gray.png"
                      alt=""
                    />
                  </button>
                </template>
              </div>
            </div>

            <div class="invite-card__row">
              <span>{{ t("invite.invitationLink") }}</span>
              <div
                class="invite-card__value invite-card__value--wide"
                :class="{ 'invite-card__value--locked': isInviteLocked }"
              >
                <template v-if="isInviteLocked">
                  <div class="value">{{ t("invite.notUnlocked") }}</div>
                  <AppSvgIcon :src="lockIcon" size="14" />
                </template>
                <template v-else>
                  <div class="value">{{ invitationLinkText }}</div>
                  <button type="button" @click="copyText(invitationLink)">
                    <app-image
                      src="@/assets/images/common_copy_icon_gray.png"
                      alt=""
                    />
                  </button>
                </template>
              </div>
            </div>

            <h3>{{ t("mine.recommender") }}</h3>
            <div class="invite-card__bind">
              <div
                class="invite-card__field"
                :class="{ 'invite-card__field--bound': isBound }"
              >
                <van-field
                  v-model="parentCode"
                  :readonly="isBound"
                  :border="false"
                  :placeholder="t('invite.enterParentCode')"
                />
                <button
                  v-if="!isBound"
                  type="button"
                  class="invite-card__scan"
                  @click="openParentScanner"
                >
                  <app-image
                    src="@/assets/images/common_scancode_icon3.png"
                    alt=""
                  />
                </button>
              </div>
              <van-button
                :type="isBound ? 'default' : 'primary'"
                class="invite-card__bind-btn"
                :class="{ 'invite-card__bind-btn--bound': isBound }"
                :disabled="isBound"
                @click="bindParent"
              >
                {{ isBound ? t("invite.bound") : t("invite.bind") }}
              </van-button>
            </div>
          </section>

          <section class="menu-card">
            <button
              v-for="item in primaryMenuItems"
              :key="item.label"
              type="button"
              class="menu-item"
              @click="handleMenu(item)"
            >
              <div class="menu-item__left">
                <AppSvgIcon
                  v-if="item.svgIcon"
                  :name="item.svgIcon"
                  size="22"
                />
                <app-image v-else-if="item.icon" :src="item.icon" alt="" />
                <van-icon v-else :name="item.vanIcon" />
                <span>{{ item.label }}</span>
              </div>
              <div class="menu-item__right">
                <div
                  v-if="item.badge"
                  class="mine-status-badge"
                  :class="item.badge.className"
                >
                  <app-image
                    v-if="item.badge.icon"
                    :src="item.badge.icon"
                    alt=""
                  />
                  {{ item.badge.label }}
                </div>
                <van-icon name="arrow" size="16" color="#999999" />
              </div>
            </button>
          </section>

          <section class="menu-card">
            <button
              v-for="item in secondaryMenuItems"
              :key="item.label"
              type="button"
              class="menu-item"
              @click="handleMenu(item)"
            >
              <div class="menu-item__left">
                <AppSvgIcon
                  v-if="item.svgIcon"
                  :name="item.svgIcon"
                  size="22"
                />
                <app-image v-else-if="item.icon" :src="item.icon" alt="" />
                <van-icon v-else :name="item.vanIcon" />
                <span>{{ item.label }}</span>
              </div>
              <div class="menu-item__right">
                <small v-if="item.value">{{ item.value }}</small>
                <van-icon name="arrow" size="16" color="#999999" />
              </div>
            </button>
          </section>

          <!-- <van-button v-if="loggedIn" block round plain type="primary" class="mine-logout" @click="logout">
            {{ t('mine.logout') }}
          </van-button>
          <van-button v-else block round type="primary" class="mine-logout" @click="router.push('/login')">
            {{ t('mine.login') }}
          </van-button> -->
        </section>
      </div>
    </van-pull-refresh>

    <van-popup
      v-model:show="showNameDialog"
      class="mine-name-popup"
      position="bottom"
      round
      transition="van-popup-slide-bottom"
      @open="syncNameInput"
    >
      <div class="mine-name-popup__content">
        <div class="mine-name-popup__header">
          <span>{{ t("mine.changeWalletName") }}</span>
          <button
            type="button"
            class="mine-name-popup__close"
            :aria-label="t('common.close')"
            @click="showNameDialog = false"
          >
            <van-icon name="cross" size="24" />
          </button>
        </div>
        <van-field
          v-model="nameInput"
          class="mine-name-field"
          clearable
          :border="false"
          maxlength="16"
          :placeholder="t('mine.enterWalletName')"
        />
        <div class="mine-name-popup__actions">
          <button
            type="button"
            class="mine-name-popup__button mine-name-popup__button--cancel"
            :disabled="nameSubmitting"
            @click="showNameDialog = false"
          >
            {{ t("common.cancel") }}
          </button>
          <button
            type="button"
            class="mine-name-popup__button mine-name-popup__button--confirm"
            :disabled="nameSubmitting"
            @click="confirmNameChange"
          >
            {{ t("common.confirm") }}
          </button>
        </div>
      </div>
    </van-popup>

    <CardCodeRedeemPopup v-model:show="showCardCodePopup" />

    <van-action-sheet
      v-model:show="showAvatarActionSheet"
      :actions="avatarActionList"
      :cancel-text="t('common.cancel')"
      close-on-click-action
      @select="handleAvatarActionSelect"
    />

    <van-popup
      v-model:show="showCheckInPopup"
      class="checkin-popup"
      :close-on-click-overlay="false"
    >
      <section class="checkin-dialog">
        <div class="checkin-dialog__panel">
          <h2>{{ t("task.dailyCheckIn") }}</h2>

          <div class="checkin-dialog__content">
            <header class="checkin-dialog__head">
              <span>{{ t("task.moreCheckInsMorePoints") }}</span>
              <button type="button" @click="openCheckInRules">
                {{ t("task.checkInRules") }}
                <van-icon name="arrow" />
              </button>
            </header>

            <div class="checkin-dialog__week">
              <article
                v-for="(item, index) in checkInWeekList"
                :key="`${item.dateTimestamp || item.weekCode}-${index}`"
                class="checkin-dialog__day"
                :class="checkInDayClass(item)"
              >
                <span>+{{ item.amount }}</span>
                <app-image :src="checkInDayIcon(item)" alt="" />
                <div :class="item.amount > 0 ? 'border' : ''" data-strong>
                  {{ monthDayLabel(item.dateTimestamp) }}
                </div>
              </article>
            </div>

            <button
              type="button"
              class="checkin-dialog__submit"
              @click="submitCheckIn"
            >
              {{ canCheckIn ? t("mine.signIn") : t("mine.signedIn") }}
            </button>
            <p>
              {{ t("task.checkedInDaysPrefix") }}{{ continuousCheckInCount
              }}{{ t("task.checkedInDaysSuffix") }}
            </p>
          </div>
        </div>

        <button
          type="button"
          class="checkin-dialog__close"
          @click="showCheckInPopup = false"
        >
          <app-image :src="signCloseIcon" alt="" />
        </button>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showCheckInRules"
      class="checkin-rules-popup"
      :overlay="false"
      :close-on-click-overlay="false"
    >
      <p>{{ t("task.checkInRuleOne") }}</p>
      <p>{{ t("task.checkInRuleTwo") }}</p>
    </van-popup>

    <van-popup
      v-model:show="showCheckInReminder"
      class="checkin-reminder-popup"
      :overlay="false"
      :close-on-click-overlay="false"
    >
      <van-icon name="passed" />
      <span>{{ t("task.checkedInTodayTomorrow") }}</span>
    </van-popup>
  </section>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { closeToast, showFailToast, showLoadingToast, showToast } from "vant";
import { showPassedToast } from "@/utils/toast";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { uploadAvatarFile, userUpdate } from "@/api/auth";
import { pcCardCreatePre } from "@/api/card";
import { useWalletScanner } from "@/composables/useWalletScanner";
import {
  refDoc,
  refOverview,
  ptBindParent,
  ptCheckinSubmit,
  ptInfo,
  userDirectPushList,
} from "@/api/wallet";
import { useProfileStore } from "@/stores/profile";
import {
  DEFAULT_BRAND_NAME,
  resolveBrandName,
  useThemeStore,
} from "@/stores/theme";
import { useInviteRewardStore } from "@/stores/invite-reward";
import { useWebModalStore } from "@/stores/web-modal";
import { resolveAvatarText, resolveAvatarUrl } from "@/utils/avatar";
import { copyToClipboard } from "@/utils/clipboard";
import {
  isCameraSecureContext,
  mapCameraErrorMessage,
  resolveCameraGuideType,
  showCameraGuide,
} from "@/utils/camera";
import { getRouteState, navigateWithState } from "@/utils/route-state";
import AppNavBar from "@/components/AppNavBar.vue";
import PointsLevelCard from "@/components/PointsLevelCard.vue";
import CardPaymentBanner from "@/view/main/components/CardPaymentBanner.vue";
import CardCodeRedeemPopup from "@/view/main/components/CardCodeRedeemPopup.vue";
import CustomPullRefreshHead from "@/view/main/components/CustomPullRefreshHead.vue";
import { formatCardTimestamp } from "@/view/card/utils";
import walletIcon from "@/assets/images/settingImage/setting_list_1.png";
import safeIcon from "@/assets/images/settingImage/setting_list_2.png";
import kycIcon from "@/assets/images/settingImage/setting_list_3.png";
import contactUsIcon from "@/assets/images/settingImage/setting_list_7.png";
import yesIcon from "@/assets/images/circle_yes_icon.png";
import warnIcon from "@/assets/images/warn_icon.png";
import checkIcon from "@/assets/images/check_icon.png";
import pointCardTwoIcon from "@/assets/images/settingImage/pointCard_two_icon.png";
import pointCardThreeIcon from "@/assets/images/settingImage/pointCard_three_icon.png";
import pointCardFourIcon from "@/assets/images/settingImage/pointCard_four_icon.png";
import didSignIcon from "@/assets/images/settingImage/did_sign_icon.png";
import willSignIcon from "@/assets/images/settingImage/will_sign_icon.png";
import undoSignIcon from "@/assets/images/settingImage/undo_sign_icon.png";
import signCloseIcon from "@/assets/images/settingImage/sign_X_icon.png";
import inviteLogoIcon from "@/assets/images/inviteLogo.png";
import cardCodeRedeemIcon from "@/assets/images/SVG/icon/card_code_redeem.svg";
import inviteUnlockLockBody from "@/assets/images/SVG/icon/invite-unlock-lock-body.svg";
import inviteUnlockLockKeyhole from "@/assets/images/SVG/icon/invite-unlock-lock-keyhole.svg";
import inviteUnlockLockShackle from "@/assets/images/SVG/icon/invite-unlock-lock-shackle.svg";
import lockIcon from "@/assets/images/SVG/icons/lock.svg";

const gameUrl = "https://g.bingo.vip";
const shopUrl = "https://hk.webx.ai";

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const { openWalletScanner } = useWalletScanner();
const rewardStore = useInviteRewardStore();
const webModalStore = useWebModalStore();
const profileStore = useProfileStore();
const themeStore = useThemeStore();
const pageState = computed(() => getRouteState(route, "home-mine", {}));

const refreshing = ref(false);
const mineInfo = ref({});
const inviteOverview = ref({});
const pushNum = ref("0");
const userNum = ref("--");
const kycStatus = ref(null);
const kycPreInfo = ref({});
const showNameDialog = ref(false);
const nameInput = ref("");
const nameSubmitting = ref(false);
const parentCode = ref("");
const refreshRef = ref(null);
const showHeroTopSolid = ref(false);
const pointsCardRef = ref(null);
const pointsCarouselRef = ref(null);
const avatarAlbumInputRef = ref(null);
const avatarCameraInputRef = ref(null);
const avatarUploading = ref(false);
const showAvatarActionSheet = ref(false);
const showCheckInPopup = ref(false);
const showCardCodePopup = ref(false);
const openingPartnerQuestionnaire = ref(false);
const showCheckInRules = ref(false);
const showCheckInReminder = ref(false);
let checkInRulesTimer = null;
let checkInReminderTimer = null;

const accountName = computed(() =>
  resolveBrandName(
    profileStore.currentAccount.name,
    themeStore.name || DEFAULT_BRAND_NAME,
  ),
);
const avatarText = computed(() => resolveAvatarText(accountName.value));
const avatarUrl = computed(() =>
  resolveAvatarUrl(profileStore.currentAccount.avatar),
);
const loggedIn = computed(() => Boolean(profileStore.currentAccountAddress));
const pointsNumber = computed(() => Number(mineInfo.value?.ptAmount || 0));
const rewardPreviewList = computed(() => rewardStore.previewList);
const invitationCodeText = computed(
  () => mineInfo.value?.invitationCode || "--",
);
const invitationLink = computed(() => {
  const url = String(themeStore.url?.inviteRegisterUrl || "").trim();
  const code = String(invitationCodeText.value || "").trim();
  return url && code && code !== "--" ? `${url}${code}` : "--";
});
const invitationLinkText = computed(() => {
  const text = String(invitationLink.value || "").trim();
  if (!text || text === "--") {
    return "--";
  }
  if (text.length <= 10) {
    return text;
  }
  return `${text.slice(0, 5)}...${text.slice(-5)}`;
});
const isBound = computed(() => Number(inviteOverview.value?.isBind || 0) === 1);
const isInviteLocked = computed(() => {
  const value = inviteOverview.value?.refFlag;
  if (value === true) return false;
  if (value === false) return true;

  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();
  return normalized === "false" || normalized === "0";
});
const canCheckIn = computed(() => {
  const list = Array.isArray(mineInfo.value?.checkInList)
    ? mineInfo.value.checkInList
    : [];
  return list.some(
    (item) => Number(item?.isToday) === 1 && Number(item?.isCheckIn) === 0,
  );
});
const checkInWeekList = computed(() => {
  const list = Array.isArray(mineInfo.value?.checkInList)
    ? mineInfo.value.checkInList
    : [];
  return list.slice(0, 7);
});
const continuousCheckInCount = computed(() => {
  const list = [...checkInWeekList.value].sort(
    (left, right) =>
      Number(left?.dateTimestamp || 0) - Number(right?.dateTimestamp || 0),
  );
  if (!list.length) {
    return 0;
  }

  let endIndex = list.findIndex((item) => Number(item?.isToday) === 1);
  if (endIndex < 0) {
    endIndex = list.length - 1;
  }
  if (Number(list[endIndex]?.isCheckIn) !== 1) {
    endIndex -= 1;
  }

  let count = 0;
  let nextDate = null;
  for (let index = endIndex; index >= 0; index -= 1) {
    const item = list[index];
    if (Number(item?.isCheckIn) !== 1) {
      break;
    }
    const date = checkInDate(item?.dateTimestamp);
    if (!date || (nextDate && Math.round((nextDate - date) / 86400000) !== 1)) {
      break;
    }
    count += 1;
    nextDate = date;
  }
  return count;
});
const avatarActionList = computed(() => [
  { name: t("mine.takePhoto"), key: "camera" },
  { name: t("mine.chooseFromAlbum"), key: "album" },
]);

async function openPartnerQuestionnaire() {
  if (openingPartnerQuestionnaire.value) {
    return;
  }

  const address = profileStore.platformAddress || null;
  if (!address) {
    return;
  }

  openingPartnerQuestionnaire.value = true;
  try {
    const result = await refDoc(
      {
        address,
        lang: locale.value || profileStore.locale || "zh-CN",
      },
      { meta: { showLoading: false } },
    );
    const url = String(result?.questionnaireUrl || "").trim();
    if (!url) {
      showFailToast(t("common.retryLater"));
      return;
    }
    webModalStore.open({
      url,
      title: t("invite.partnerJoinNow"),
      navBackgroundColor: "#fff",
    });
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    openingPartnerQuestionnaire.value = false;
  }
}
const levelCards = computed(() => {
  const invitedCount = Number(inviteOverview.value?.refCnt || 0);
  const levels = Array.isArray(inviteOverview.value?.levels)
    ? [...inviteOverview.value.levels].sort(
        (left, right) => Number(left?.level || 0) - Number(right?.level || 0),
      )
    : [];
  const styles = [
    {
      svgIcon: "point-card-one",
      primaryColor: "var(--wp-color-brand-1)",
      descColor: "var(--wp-color-brand-1)",
      barBg: "var(--wp-color-brand-6)",
      barColor: "var(--wp-color-brand-1)",
      tagColor: "var(--wp-color-brand-1)",
      tagTextColor: "#ffffff",
      cardStyle: {
        background:
          "linear-gradient(180deg, var(--wp-color-brand-6) 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(50, 55, 173, 0.10)",
      },
    },
    {
      icon: pointCardTwoIcon,
      primaryColor: "#234796",
      descColor: "#3e67c0",
      barBg: "#b3dcff",
      barColor: "#234796",
      tagColor: "#234796",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #aed9ff 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(223, 240, 255, 1)",
      },
    },
    {
      icon: pointCardThreeIcon,
      primaryColor: "#b15921",
      descColor: "#e08449",
      barBg: "#f9e5c3",
      barColor: "#b15921",
      tagColor: "#b15921",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #fce8c3 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(246, 198, 113, 0.20)",
      },
    },
  ];
  const partnerStyle = {
    icon: pointCardFourIcon,
    primaryColor: "#ffeaa3",
    descColor: "#ffeaa3",
    barBg: "#8d8c8c",
    barColor: "#ffeaa3",
    tagColor: "#ffeaa3",
    tagTextColor: "#414141",
    cardStyle: { background: "#4e4d4d", boxShadow: "none" },
  };

  return levels.map((level, index) => {
    const isPartner = Number(level?.partner) === 1;
    const style = isPartner ? partnerStyle : styles[index % styles.length];
    const minCount = Number(level?.minCnt || 0);
    const displayInvitedCount = Math.min(invitedCount, minCount);
    const cardLevel = Number(level?.level || index + 1);
    const progress =
      minCount > 0
        ? Math.min(100, Math.max(0, (invitedCount / minCount) * 100))
        : 100;

    return {
      ...style,
      label: String(level?.name || `LV.${level?.level || index + 1}`),
      level: cardLevel,
      isCurrent: Number(level?.current) === 1,
      isPartner,
      isShowBar: minCount > 0,
      progress,
      hint: `${displayInvitedCount}/${minCount}`,
      monthRatePercent: String(level?.monthRatePercent || "0%"),
      metrics: [
        {
          label: t("invite.purchaseCommission"),
          icon: "info-o",
          action: "purchaseCommission",
          value: String(level?.openRatePercent || "0%"),
        },
        {
          label: t("invite.consumptionCommission"),
          icon: "info-o",
          action: "consumptionCommission",
          value: String(level?.directRatePercent || "0%"),
        },
        {
          label: t("invite.invitationTotal"),
          isCount: true,
          value: String(invitedCount),
          click: openRecommendedUsers,
        },
      ],
    };
  });
});

const currentLevelIndex = computed(() => {
  const index = levelCards.value.findIndex((card) => card.isCurrent);
  return index >= 0 ? index : 0;
});

const kycRejectReason = computed(() =>
  String(kycPreInfo.value?.reason || "").trim(),
);
const isKycRejected = computed(
  () =>
    kycStatus.value === 4 ||
    (kycStatus.value === 1 && Boolean(kycRejectReason.value)),
);

const kycStatusMeta = computed(() => {
  if (kycStatus.value === 3) {
    return {
      label: t("mine.kycVerified"),
      className: "mine-status-badge--success",
      icon: yesIcon,
    };
  }
  if (kycStatus.value === 2) {
    return {
      label: t("mine.kycPending"),
      className: "mine-status-badge--pending",
      icon: checkIcon,
    };
  }
  if (isKycRejected.value) {
    return {
      label: t("mine.kycFailed"),
      className: "mine-status-badge--failed",
      icon: warnIcon,
    };
  }
  if (kycStatus.value === 1) {
    return {
      label: t("mine.kycTodo"),
      className: "mine-status-badge--failed",
      icon: warnIcon,
    };
  }
  return {
    label: t("mine.kycTodo"),
    className: "mine-status-badge--todo",
    icon: warnIcon,
  };
});

const primaryMenuItems = computed(() => {
  const items = [
    // { label: t('mine.wallet'), icon: walletIcon, action: 'wallet' },
    {
      label: t("mine.cardCodeRedemption"),
      icon: cardCodeRedeemIcon,
      action: "cardCodeRedemption",
    },
    { label: t("mine.security"), icon: safeIcon, action: "security" },
  ];
  if (loggedIn.value && kycStatus.value !== null) {
    items.push({
      label: t("mine.kyc"),
      icon: kycIcon,
      action: "kyc",
      badge: kycStatusMeta.value,
    });
  }
  items.push({
    label: t("mine.inviteFriends"),
    svgIcon: "gift",
    to: "/wallet/invite",
  });
  return items;
});

const secondaryMenuItems = computed(() => [
  {
    label: t("mine.language"),
    svgIcon: "sphere",
    to: "/mine/language",
  },
  { label: t("mine.contactUs"), icon: contactUsIcon, to: "/mine/about" },
]);

async function loadMineData(loading = true) {
  const address = profileStore.platformAddress;
  const silentLoadingConfig = { meta: { showLoading: loading } };
  if (!address) {
    mineInfo.value = {};
    inviteOverview.value = {};
    pushNum.value = "0";
    userNum.value = "--";
    kycStatus.value = null;
    kycPreInfo.value = {};
    parentCode.value = "";
    rewardStore.reset();
    refreshing.value = false;
    return;
  }

  await Promise.allSettled([
    (async () => {
      const result = await ptInfo({ address }, silentLoadingConfig);
      mineInfo.value = result || {};
      userNum.value = String(result?.userNum ?? "--");
    })(),
    (async () => {
      const result = await pcCardCreatePre({ address }, silentLoadingConfig);
      kycPreInfo.value = result || {};
      kycStatus.value = Number(result?.holderStatus || 1);
    })(),
    (async () => {
      const result = await userDirectPushList(
        { address, pageNum: 1, pageSize: 999 },
        silentLoadingConfig,
      );
      pushNum.value = String(result?.total ?? 0);
    })(),
    (async () => {
      try {
        const result = await refOverview(
          {
            address,
            lang: locale.value || profileStore.locale || "zh-CN",
          },
          silentLoadingConfig,
        );
        inviteOverview.value = result || {};
        if (Number(inviteOverview.value?.isBind || 0) === 1) {
          parentCode.value = String(
            inviteOverview.value?.parentInvitationCode || "",
          );
        }
      } catch (error) {
        inviteOverview.value = {};
      }
    })(),
  ]);

  refreshing.value = false;
}

async function logout() {
  try {
    await showConfirmDialog({
      title: t("mine.logout"),
      message: t("mine.logoutConfirm"),
    });
    profileStore.clearAuth();
    router.push("/login");
  } catch (error) {
    // cancelled
  }
}

function copyUserId() {
  copyText(userNum.value);
}

async function copyText(text) {
  if (!text || text === "--") {
    return;
  }
  const copied = await copyToClipboard(String(text));
  if (copied) {
    showPassedToast(t("wallet.copySuccess"));
    return;
  }
  showToast(t("wallet.copyFailed"));
}

function editName() {
  nameInput.value = accountName.value;
  showNameDialog.value = true;
}

function triggerAvatarSelect() {
  if (!loggedIn.value) {
    router.push("/login");
    return;
  }
  if (avatarUploading.value) {
    return;
  }
  showAvatarActionSheet.value = true;
}

async function handleAvatarActionSelect(action) {
  if (action?.key === "camera") {
    const canOpenCamera = await ensureAvatarCameraReady();
    if (canOpenCamera) {
      avatarCameraInputRef.value?.click();
    }
    return;
  }
  avatarAlbumInputRef.value?.click();
}

function releaseMediaStream(stream) {
  stream?.getTracks?.().forEach((track) => track.stop());
}

function openRecommendedUsers() {
  router.push("/wallet/invite/recommended-users");
}

async function ensureAvatarCameraReady() {
  if (navigator.permissions?.query) {
    try {
      const status = await navigator.permissions.query({ name: "camera" });
      if (status.state === "denied") {
        showFailToast(t("wallet.cameraPermissionDenied"));
        await showCameraGuide("permission");
        return false;
      }
    } catch (error) {
      // ignore browser compatibility issues
    }
  }

  if (!isCameraSecureContext() || !navigator.mediaDevices?.getUserMedia) {
    return true;
  }

  let stream = null;
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "user" },
      audio: false,
    });
    return true;
  } catch (error) {
    showFailToast(mapCameraErrorMessage(error));
    await showCameraGuide(resolveCameraGuideType(error, "unavailable"));
    return false;
  } finally {
    releaseMediaStream(stream);
  }
}

async function handleAvatarFileChange(event) {
  const input = event?.target;
  const file = input?.files?.[0];
  if (input) {
    input.value = "";
  }
  if (!file) {
    return;
  }
  if (!String(file.type || "").startsWith("image/")) {
    showFailToast(t("mine.avatarImageOnly"));
    return;
  }
  if (file.size > 10 * 1024 * 1024) {
    showFailToast(t("mine.avatarImageTooLarge", { size: 10 }));
    return;
  }

  avatarUploading.value = true;
  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });
  try {
    const result = await uploadAvatarFile(file, {
      address: profileStore.platformAddress,
    });
    const avatar = String(result?.url || "").trim();
    if (!avatar) {
      throw new Error(t("mine.avatarUploadFailed"));
    }
    await userUpdate({
      address: profileStore.platformAddress,
      nickName: accountName.value,
      avatar,
    });
    await profileStore.setCurrentAccount({
      ...profileStore.currentAccount,
      avatar,
    });
    showPassedToast(t("mine.avatarUpdated"));
  } catch (error) {
    showFailToast(error.message || t("mine.avatarUploadFailed"));
  } finally {
    avatarUploading.value = false;
    closeToast();
  }
}

function openParentScanner() {
  openWalletScanner({
    back: "/home/mine",
    stateNamespace: "home-mine",
    statePayload: { ...pageState.value },
  });
}

function syncNameInput() {
  nameInput.value = accountName.value;
}

async function submitNameChange() {
  const name = String(nameInput.value || "").trim();
  if (!name || name === accountName.value) {
    return true;
  }
  if (name.length > 16) {
    showToast(t("mine.nameTooLong"));
    return false;
  }

  try {
    await userUpdate({
      address: profileStore.platformAddress,
      nickName: name,
      avatar: profileStore.currentAccount.avatar || null,
    });
    profileStore.setCurrentAccount({ ...profileStore.currentAccount, name });
    showPassedToast(t("mine.nameUpdated"));
    return true;
  } catch (error) {
    showToast(error.message || t("common.retryLater"));
    return false;
  }
}

async function confirmNameChange() {
  if (nameSubmitting.value) {
    return;
  }
  nameSubmitting.value = true;
  try {
    if (await submitNameChange()) {
      showNameDialog.value = false;
    }
  } finally {
    nameSubmitting.value = false;
  }
}

function openInvite(url) {
  navigateWithState(router, "/wallet/invite");
}

function openRewardDetails() {
  navigateWithState(router, "/wallet/invite/reward", {
    namespace: "wallet-invite-reward",
    payload: {
      ptAmount: pointsNumber.value,
    },
  });
}

function handleMenu(item) {
  if (item.to) {
    router.push(item.to);
    return;
  }
  if (item.action === "wallet") {
    router.push("/wallet/backup");
    return;
  }
  if (item.action === "cardCodeRedemption") {
    showCardCodePopup.value = true;
    return;
  }
  if (item.action === "security") {
    router.push("/mine/security");
    return;
  }
  if (item.action === "kyc") {
    openKycFlow();
  }
}

function openKycFlow() {
  if (!loggedIn.value) {
    router.push("/login");
    return;
  }

  const holderStatus = Number(kycPreInfo.value?.holderStatus || 1);
  const reason = kycRejectReason.value;

  if (holderStatus === 1) {
    if (reason) {
      navigateWithState(router, "/card/kyc/result", {
        namespace: "card-kyc-result",
        payload: {
          holderStatus: "1",
          reason,
        },
      });
      return;
    }
    router.push("/card/kyc");
    return;
  }

  if (holderStatus === 2 || holderStatus === 3 || holderStatus === 4) {
    navigateWithState(router, "/card/kyc/result", {
      namespace: "card-kyc-result",
      payload: {
        holderStatus: String(holderStatus),
        reason,
      },
    });
    return;
  }

  router.push("/card/kyc");
}

async function bindParent() {
  if (!loggedIn.value) {
    router.push("/login");
    return;
  }
  if (isBound.value || !parentCode.value.trim()) {
    return;
  }

  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });
  try {
    await ptBindParent({
      address: profileStore.platformAddress,
      invitationCode: parentCode.value.trim(),
    });
    showPassedToast(t("mine.bindSuccess"));
    await loadMineData();
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

async function handleCheckIn() {
  if (!loggedIn.value) {
    router.push("/login");
    return;
  }
  showCheckInPopup.value = true;
}

function checkInDate(timestamp) {
  const value = Number(timestamp || 0);
  if (!Number.isFinite(value) || value <= 0) {
    return null;
  }
  return new Date(value < 100000000000 ? value * 1000 : value);
}

function monthDayLabel(timestamp) {
  const date = checkInDate(timestamp);
  if (!date) {
    return "--";
  }
  if (
    String(locale.value || "")
      .toLowerCase()
      .startsWith("zh")
  ) {
    return `${date.getMonth() + 1}月${date.getDate()}日`;
  }
  return `${date.getMonth() + 1}-${date.getDate()}`;
}

function checkInDayClass(item = {}) {
  if (Number(item?.status) === 0 && Number(item?.isCheckIn) === 0) {
    return "checkin-dialog__day--expired";
  }
  if (Number(item?.isCheckIn) === 1) {
    return "checkin-dialog__day--checked";
  }
  return "checkin-dialog__day--todo";
}

function checkInDayIcon(item = {}) {
  if (Number(item?.status) === 0 && Number(item?.isCheckIn) === 0) {
    return undoSignIcon;
  }
  return Number(item?.isCheckIn) === 1 ? didSignIcon : willSignIcon;
}

function openCheckInRules() {
  window.clearTimeout(checkInRulesTimer);
  showCheckInRules.value = true;
  checkInRulesTimer = window.setTimeout(() => {
    showCheckInRules.value = false;
    checkInRulesTimer = null;
  }, 3000);
}

function openCheckInReminder() {
  window.clearTimeout(checkInReminderTimer);
  showCheckInReminder.value = true;
  checkInReminderTimer = window.setTimeout(() => {
    showCheckInReminder.value = false;
    checkInReminderTimer = null;
  }, 2000);
}

async function submitCheckIn() {
  if (!canCheckIn.value) {
    openCheckInReminder();
    return;
  }
  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });
  try {
    const result = await ptCheckinSubmit({
      address: profileStore.platformAddress,
    });
    const today = Array.isArray(mineInfo.value?.checkInList)
      ? mineInfo.value.checkInList.find((item) => Number(item?.isToday) === 1)
      : null;
    if (today) {
      today.isCheckIn = 1;
    }
    showPassedToast(t("mine.checkInSuccess", { reward: result?.reward || 0 }));
    await loadMineData(false);
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

function parseInvitationCodeFromScan(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) {
    return "";
  }
  if (value.includes("r=")) {
    const part = value.split("r=")[1] || "";
    return part.split("&")[0] || "";
  }
  return value.split("&")[0] || value;
}

watch(
  () => pageState.value.scanResult,
  (value) => {
    if (!value || isBound.value) {
      return;
    }
    parentCode.value = parseInvitationCodeFromScan(value);
    navigateWithState(router, route.path, {
      namespace: "home-mine",
      replace: true,
      payload: {
        ...pageState.value,
        scanResult: "",
      },
    });
  },
  { immediate: true },
);

watch(
  currentLevelIndex,
  async (value) => {
    await nextTick();
    scrollPointsToLevel(value);
  },
  { immediate: true },
);

function getRefreshElement() {
  return refreshRef.value?.$el || refreshRef.value || null;
}

function scrollPointsToLevel(index = 0) {
  const container = pointsCarouselRef.value;
  const children = container?.children || [];
  const target = children[index];
  if (!container || !target) {
    return;
  }

  const leftInset =
    Number.parseFloat(window.getComputedStyle(container).paddingLeft) || 0;

  container.scrollTo({
    left: Math.max(0, target.offsetLeft - leftInset),
    behavior: "auto",
  });
}

function handlePointsResize() {
  scrollPointsToLevel(currentLevelIndex.value);
}

function syncHeroTopState() {
  const element = getRefreshElement();
  const scrollTop = element?.scrollTop || 0;
  showHeroTopSolid.value = scrollTop > 0;
}

onMounted(() => {
  if (pageState.value?.openCardCodePopup) {
    showCardCodePopup.value = true;
    navigateWithState(router, route.path, {
      namespace: "home-mine",
      replace: true,
      payload: {
        ...pageState.value,
        openCardCodePopup: false,
      },
    });
  }
  loadMineData();
  syncHeroTopState();
  window.addEventListener("resize", handlePointsResize, { passive: true });
  getRefreshElement()?.addEventListener("scroll", syncHeroTopState, {
    passive: true,
  });
});

onUnmounted(() => {
  window.clearTimeout(checkInRulesTimer);
  window.clearTimeout(checkInReminderTimer);
  window.removeEventListener("resize", handlePointsResize);
  getRefreshElement()?.removeEventListener("scroll", syncHeroTopState);
});
</script>

<style scoped lang="scss">
.mine-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  background: #f7f8fa;
  overflow: hidden;
}

.mine-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.mine-refresh {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.mine-tab {
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
}

.mine-card-payment {
  width: calc(100% - 28px);
  margin: 0 14px 16px;
}

.mine-hero {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  padding: calc(
      env(safe-area-inset-top) + var(--van-nav-bar-height, 46px) + 26px
    )
    0 0;
  color: #ffffff;
}

.mine-hero::before {
  display: none;
}

.mine-hero__background {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: calc(100% - 60px);
  min-height: 240px;
  color: var(--wp-color-brand-1);
  --mine-bg-start: var(--wp-color-brand-2);
  --mine-bg-end: var(--wp-color-brand-1);
  pointer-events: none;
}

:deep(.mine-hero__nav.van-nav-bar) {
  z-index: 20;
  transition: background-color 0.2s ease;
}

:deep(.mine-hero__nav.van-nav-bar::after) {
  border-bottom: 0;
}

:deep(.mine-hero__nav .van-nav-bar__content) {
  height: calc(var(--van-nav-bar-height, 46px) + env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
}

:deep(.mine-hero__nav .van-nav-bar__right) {
  right: 14px;
}

.mine-hero__qr {
  display: block;
  width: 24px;
  height: 24px;
}

.mine-hero__profile {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 14px;
  &_information {
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
  }
  &_invite {
    flex: 0 0 auto;
    border-radius: 30px;
    padding: 12px 10px 12px 12px;
    background: linear-gradient(247deg, #fdff89 14.84%, #d0fcff 86.54%);
    color: #2b2b2b;
    font-size: 14px;
    line-height: 1.4;
    white-space: nowrap;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 2px;
    margin-right: 2px;
    .invite {
      width: 18px;
      height: 18px;
      object-fit: contain;
    }
  }
}

.mine-hero__avatar-wrap {
  position: relative;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  // overflow: hidden;
}

.mine-hero__avatar-input {
  display: none;
}

.mine-hero__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    var(--wp-color-brand-2),
    var(--wp-color-brand-3)
  );
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.mine-hero__avatar-image {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.mine-hero__avatar-edit {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
}

.mine-hero__info {
  flex: 1;
  min-width: 0;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.mine-hero__name-row {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  font-size: 16px;
  line-height: 1.4;

  .accountName {
    min-width: 0;
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 700;
  }

  button {
    display: inline-flex;
    flex: 0 0 auto;
    padding: 0;
    border: 0;
    background: transparent;

    .app-image {
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }
  }
}

.mine-hero__id {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #dedede;
  font-size: 12px;
  line-height: 1.4;
  min-width: 0;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .app-image {
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
  }
}

.mine-hero__sign {
  margin-top: 8px;
  min-width: 66px;
  height: 26px;
  padding: 0 14px;
  border: 0;
  border-radius: 20px;
  background: #ffffff;
  color: var(--wp-color-brand-1);
  font-size: 14px;

  &--done {
    color: #8c94a5;
  }
}

.points-card {
  position: relative;
  flex-shrink: 0;
  margin-top: 32px;
  min-height: 148px;
  box-sizing: border-box;
  z-index: 1;
  overflow: hidden;
}

.points-card__carousel {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-right: 16px;
  padding-left: 14px;
  // padding-bottom: 8px;
  scroll-padding-left: 14px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.points-card__item {
  flex: 0 0 calc(100% - 16px);
  width: calc(100% - 16px);
  padding-bottom: 6px;
  box-sizing: border-box;
  scroll-snap-align: start;
}

.mine-zones {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 10px 14px 0;
}

.mine-zone {
  min-height: 98px;
  padding: 10px 14px;
  border: 0;
  border-radius: 16px;
  color: #ffffff;
  text-align: left;

  [data-strong],
  span,
  em {
    display: block;
  }

  [data-strong] {
    font-size: 16px;
    font-weight: 500;
  }

  span {
    margin-top: 5px;
    font-size: 12px;
  }

  em {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 70px;
    height: 26px;
    margin-top: 10px;
    border-radius: 30px;
    background: var(--wp-color-theme);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.18);
    font-size: 12px;
    font-style: normal;
  }
}

.mine-zone--game {
  background: url("@/assets/images/settingImage/game_bg.png") center / cover
    no-repeat;
}

.mine-zone--shop {
  background: url("@/assets/images/settingImage/shopping_bg.png") center / cover
    no-repeat;
}

.invite-card {
  margin: 0px 14px 0;
  padding: 18px 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  &-label {
    display: flex;
    justify-content: space-between;
    margin: 0;
    color: #000000;
    font-size: 16px;
    font-weight: 700;
    span {
      color: var(--wp-color-brand-1);
      font-size: 12px;
      font-weight: 500;
    }

    &__arrow {
      font-weight: 700;
      -webkit-text-stroke: 0.4px currentColor;
    }
  }
}

.menu-card {
  margin: 16px 14px 0;
  padding: 18px 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;

  i {
    width: 4px;
    height: 18px;
    border-radius: 999px;
    background: #f7811a;
  }

  h2 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
  }
}

.invite-card {
  h2,
  h3 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    font-weight: 700;
  }

  h3 {
    margin-top: 18px;
  }
}

.invite-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  margin-top: 14px;
  padding: 0 14px;
  border-radius: 10px;
  background: #f4f5f6;
  gap: 12px;
  font-size: 14px;

  > span {
    flex: 0 0 92px;
    color: #333333;
    white-space: nowrap;
  }
}

.invite-card__unlock-tip {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 58px;
  margin-top: 14px;
  padding: 13px 12px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #f7f3ff;
}

.invite-card__unlock-icon {
  position: relative;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;

  img {
    position: absolute;
    display: block;
    max-width: none;
  }
}

.invite-card__unlock-icon-body {
  top: 10px;
  left: 2px;
  width: 20px;
  height: 13px;
}

.invite-card__unlock-icon-shackle {
  top: 1px;
  left: 6px;
  width: 12px;
  height: 11px;
}

.invite-card__unlock-icon-keyhole {
  top: 15px;
  left: 11px;
  width: 2px;
  height: 5px;
}

.invite-card__unlock-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  p {
    width: 100%;
    margin: 0;
    overflow-wrap: break-word;
  }

  p:first-child {
    color: #7442e8;
    font-size: 13px;
    font-weight: 600;
    line-height: 13px;
  }

  p:last-child {
    color: #747b88;
    font-size: 11px;
    font-weight: 400;
    line-height: 10px;
  }
}

.invite-card__value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
  gap: 6px;
  color: #999;

  .value {
    color: #333333;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 18px;
    height: 18px;
  }
}

.invite-card__value--wide [data-strong] {
  max-width: 180px;
}

.invite-card__bind {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.invite-card__field {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  border-radius: 10px;
  background: #f4f5f6;

  :deep(.van-cell) {
    flex: 1;
    padding: 0 0 0 12px;
    background: transparent;
  }

  :deep(.van-field__control) {
    height: 44px;
    font-size: 15px;
    font-weight: 500;
  }
}

.invite-card__field--bound {
  :deep(.van-field__control) {
    font-size: 16px;
    // font-weight: 500;
    letter-spacing: 1px;
  }
}

.invite-card__scan {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.invite-card__bind-btn {
  flex: 0 0 84px;
  height: 44px;
  --van-button-border-radius: 10px;
  --van-button-primary-border-color: var(--wp-color-button-2);
  --van-button-primary-background: var(--wp-color-button-2);
  --van-button-primary-color: var(--wp-color-brand-1);

  :deep(.van-button) {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }

  :deep(.van-button--disabled.van-button--primary) {
    opacity: 1;
    border-color: var(--wp-color-button-2);
    background: var(--wp-color-button-2);
    color: #a9c1ff;
  }
}

.invite-card__bind-btn--bound {
  --van-button-default-border-color: #f4f5f6;
  // --van-button-default-background: #f4f5f6;
  // --van-button-default-color: #999999;
  background: #f4f5f6 !important;
  color: #999 !important;
  font-weight: 500;
  border-radius: 12px;
  :deep(.van-button) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
  }

  :deep(.van-button--default) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
  }
}

.reward-card {
  padding: 18px 16px;
}

.reward-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.reward-card-head__title {
  margin-bottom: 0;
}

.reward-card-head__more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--wp-color-theme);
  font-size: 14px;

  .app-image {
    width: 10px;
    height: 10px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(33%) sepia(94%) saturate(4438%)
      hue-rotate(220deg) brightness(101%) contrast(101%);
  }
}

.reward-preview-list {
  margin-top: 14px;
}

.reward-preview__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #f4f5f6;

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  [data-strong],
  span {
    display: block;
  }

  > div:first-child {
    min-width: 0;
    flex: 1;
  }

  > div:first-child [data-strong] {
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
  }

  > div:first-child span {
    margin-top: 4px;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview__amount {
  flex: 0 0 auto;
  text-align: right;

  [data-strong] {
    color: var(--wp-color-theme);
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
  }

  span {
    margin-top: 4px;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 0;
  color: #999999;

  .app-image {
    width: 116px;
    height: 116px;
    object-fit: contain;
  }

  span {
    margin-top: -8px;
    font-size: 14px;
    line-height: 20px;
  }
}

.menu-card {
  padding: 5px 16px;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  padding: 11px 0;
  border: 0;
  border-bottom: 1px solid #f4f5f6;
  background: transparent;
  text-align: left;

  &:last-child {
    border-bottom: 0;
  }
}

.menu-item__left,
.menu-item__right {
  display: flex;
  align-items: center;
}

.menu-item__left {
  gap: 10px;

  .app-image,
  .app-svg-icon {
    display: block;
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  .van-icon {
    font-size: 22px;
    color: #222222;
  }

  span {
    color: #222222;
    font-size: 16px;
    font-weight: 500;
  }
}

.menu-item__right {
  gap: 10px;

  :deep(.van-icon) {
    font-size: initial;
  }

  small {
    color: #999999;
    font-size: 12px;
  }
}

.mine-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 14px;
  font-size: 12px;
  line-height: 1;

  .app-image {
    width: 14px;
    height: 14px;
  }

  &--todo {
    color: #ef0027;
    background: #ffdae0;
  }

  &--pending {
    color: #ff8800;
    background: rgba(255, 231, 161, 0.55);
  }

  &--success {
    color: #07b077;
    background: rgba(194, 255, 234, 0.6);
  }

  &--failed {
    color: #ef0027;
    background: #ffdae0;
  }
}

.mine-name-field {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  margin: 16px 0 0;
  padding: 0 10px;
  border-radius: 10px;
  background: #f2f3f5;

  :deep(.van-cell__value) {
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: center;
  }

  :deep(.van-field__body) {
    width: 100%;
    min-width: 0;
  }

  :deep(.van-field__control) {
    flex: 1;
    min-width: 0;
    color: #111111;
    font-size: 16px;
    line-height: 24px;
  }
}

:global(.mine-name-popup.van-popup--bottom) {
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  border-radius: 20px 20px 0 0;
  background: #ffffff;
}

:global(.mine-name-popup__content) {
  box-sizing: border-box;
  padding: 20px 16px 22px;
}

:global(.mine-name-popup__header) {
  position: relative;
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: center;
  color: #111111;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
}

:global(.mine-name-popup__close) {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #666666;
  font-size: 22px;
}

:global(.mine-name-popup__actions) {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

:global(.mine-name-popup__button) {
  box-sizing: border-box;
  height: 40px;
  flex: 1;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
}

:global(.mine-name-popup__button:disabled) {
  opacity: 0.65;
}

:global(.mine-name-popup__button--cancel) {
  background: #f1eaff;
  color: var(--wp-color-brand-1);
}

:global(.mine-name-popup__button--confirm) {
  background: var(--wp-color-brand-1);
  color: #ffffff;
}

.checkin-popup {
  overflow: visible;
  width: min(calc(100vw - 32px), 390px);
  background: transparent;
}

.checkin-dialog {
  position: relative;
  padding-bottom: 52px;
}

.checkin-dialog__panel {
  padding: 16px 12px;
  border-radius: 16px;
  background: linear-gradient(180deg, #cdd9fa 0%, #82b3ff 100%);
}

.checkin-dialog__panel h2 {
  margin: 0 0 10px;
  color: #202020;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
}

.checkin-dialog__content {
  padding: 16px 12px 12px;
  border-radius: 16px;
  background: #ffffff;
}

.checkin-dialog__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #666666;
  font-size: 12px;
  line-height: 18px;
}

.checkin-dialog__head button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #5f64ee;
  font-size: 12px;
}

.checkin-dialog__head :deep(.van-icon) {
  font-size: 12px;
}

.checkin-dialog__week {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px 20px;
  margin-top: 16px;
}

.checkin-dialog__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  padding-top: 5px;
  // border: 1px solid transparent;
  border-radius: 12px;
  background: #edf1ff;
}

.checkin-dialog__day--checked {
  background: #d9e3ff;
}

.checkin-dialog__day--expired {
  background: #e7e5e5;
}

.checkin-dialog__day:nth-child(7) {
  grid-column: span 2;
}

.checkin-dialog__day > span {
  color: #5f64ee;
  font-size: 12px;
  line-height: 16px;
}

.checkin-dialog__day .app-image {
  width: 26px;
  height: 27px;
  margin: 3px 0 5px;
}

.border {
  border: 1px solid #edf1ff;
}

.checkin-dialog__day > [data-strong] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 22px;
  padding: 3px 6px;
  border-radius: 0 0 10px 10px;
  background: #5f64ee;
  color: #ffffff;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
}

.checkin-dialog__day--expired > span {
  color: #999999;
}

.checkin-dialog__day--expired > [data-strong] {
  background: #d8d8d8;
  color: #666666;
}

.checkin-dialog__submit {
  width: 100%;
  height: 44px;
  margin-top: 18px;
  border: 0;
  border-radius: 22px;
  background: #5f64ee;
  box-shadow: 0 4px 4px #d3d4ff;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.checkin-dialog__content > p {
  margin: 10px 0 0;
  color: #5f64ee;
  font-size: 12px;
  line-height: 18px;
}

.checkin-dialog__close {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  transform: translateX(-50%);
}

.checkin-dialog__close .app-image {
  width: 42px;
  height: 42px;
}

.checkin-rules-popup {
  width: min(calc(100vw - 64px), 320px);
  padding: 20px 16px;
  border: 1px solid rgba(26, 26, 26, 0.12);
  border-radius: 8px;
  background: rgba(39, 39, 42, 0.95);
  color: #ffffff;
}

.checkin-rules-popup p {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
}

.checkin-rules-popup p + p {
  margin-top: 10px;
}

.checkin-reminder-popup.van-popup {
  display: inline-grid;
  grid-template-columns: 12px max-content;
  align-items: center;
  column-gap: 5px;
  width: fit-content;
  padding: 15px 8px;
  box-sizing: border-box;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
}

.checkin-reminder-popup.van-popup :deep(.van-icon) {
  width: 14px;
  height: 14px;
  font-size: 18px;
  line-height: 13px;
}

.checkin-reminder-popup.van-popup span {
  margin: 0;
  font-size: 16px;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 5px;
}
</style>
